// extracted by mini-css-extract-plugin
export default {"emptyStatesContainer":"_2sFCs"};